module.exports = __webpack_public_path__ + "img/head_icon.jpg";